import { createFileRoute } from "@tanstack/react-router";

import CreateRoundScorePage from "~/pages/game/CreateRoundScorePage";

type CreateRoundScoreSearch = {
    /** The number of recorded answers. Each score taking step has its own history entry. */
    step: number;
};

export const Route = createFileRoute("/_auth/game-session/$gameSessionId/score-taking/games/$gameId/rounds/")({
    validateSearch: (search: Record<string, unknown>): CreateRoundScoreSearch => ({
        step: typeof search.step === "number" && Number.isInteger(search.step) && search.step >= 0 ? search.step : 0,
    }),
    component: CreateRoundScorePage,
});
